var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:_vm.button.class,attrs:{"title":_vm.button.title},on:{"click":_vm.click}},[(_vm.button.icon)?_c('i',{class:_vm.button.icon}):_vm._e(),_vm._v(" "+_vm._s(_vm.button.label)+" "),(_vm.button.iconRight)?_c('i',{class:_vm.button.iconRight}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }